import { cn } from '@form-factory/chatbot-ui';
import { Trans } from '@lingui/react/macro';
import { Select as InformedSelect } from 'informed';
import { ChevronDown } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';

export interface NativeFormSelectProps
  extends ComponentPropsWithoutRef<typeof InformedSelect> {}

/**
 * Custom styles for native select component to match utima UI
 */
export function NativeFormSelect({
  className,
  children,
  ...restProps
}: NativeFormSelectProps) {
  return (
    <div className='relative [&_label]:mb-2 [&_label]:block [&_label]:text-sm [&_label]:font-medium [&_label]:text-chat-foreground [&_small]:text-xs [&_small]:text-chat-destructive'>
      <InformedSelect
        className={cn(
          'relative flex h-9 px-3 py-2 w-full min-w-full appearance-none rounded-radius bg-chat-input-background text-sm text-chat-input-foreground border border-chat-input-border outline-none transition-all disabled:cursor-not-allowed disabled:opacity-75 rounded-md',
          className,
        )}
        {...restProps}
      >
        <option disabled selected value=''>
          <Trans>Select</Trans>
        </option>
        {children}
      </InformedSelect>
      <div className='pointer-events-none absolute right-3 top-[38px] text-chat-input-foreground'>
        <ChevronDown className='size-4' />
      </div>
    </div>
  );
}
